import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import {Button, Modal} from 'antd';
import withPageEntry from '../../withPageEntry';
import * as AppActions from '../../AppActions';
import NavLink from '../../Components/NavLink';
import CartList from '../../Components/CartList';
import useStickyTop from '../../Hooks/useStickyTop';
import tracker from './tracker';
import NavUrl, {PredefinedRoute} from '../../Utils/NavUrl';
import CheckoutPageWrapper from '../../Components/CheckoutPageWrapper';
import CheckoutSummary from '../../Components/CheckoutSummary';

const L = AppActions.L;

function renderCartEmpty() {
  return (
    <div className="window-container">
      <div className="header">
        <div />
        <div />
        <div />
      </div>
      <div className="content">
        <img
          className="cart-empty"
          src="/images/site-cartempty.png"
          alt="cartempty"
        />
        <h1>{L('cart_empty')}</h1>
        <h2>{L('cart_empty_title')}</h2>
        <p>{L('cart_empty_content')}</p>
        <NavLink to="/products?sort=-session.date">
          <button>{L('shopping')}</button>
        </NavLink>
        <NavLink to="/profile/orders" style={{marginTop: 10}}>
          <button style={{backgroundColor: 'var(--secondColor)'}}>
            查看報名紀錄
          </button>
        </NavLink>
      </div>
    </div>
  );
}

function renderCustomComponent() {
  return null;
}

function getExtraCartPageProps() {
  return {
    stickyTop: 84,
    renderCartEmpty,
    renderCustomComponent,
    cartItemCustomRenderer: () => null,
  };
}

function CartPage(props) {
  const {
    renderCartEmpty,
    stickyTop: clientStickyTop = null,
    renderCustomComponent = null,
    cartItemCustomRenderer = null,
    cartListCustomRenderer = null,
    checkoutSummaryProps = {},
    pageContext: {pageId = 'rev-CartPage'} = {},
  } = props;

  const [cart] = useOutlet('cart');
  const [user] = useOutlet('user');
  const [modal, contextHolder] = Modal.useModal();
  const {stickyTop, sideElemRef} = useStickyTop(clientStickyTop);

  React.useLayoutEffect(() => {
    if ((cart?.items || []).length === 0) {
      return;
    }

    tracker.viewCart({cart});
  }, [cart]);

  const cartItems = cart?.items || [];

  return (
    <Wrapper id={pageId} stickyTop={stickyTop}>
      <div className="container">
        <div className="main">
          {cartItems.length === 0 &&
            (typeof renderCartEmpty === 'function' ? (
              renderCartEmpty()
            ) : (
              <div>
                <h3 style={{margin: '10px 0'}}>{L('cart_empty_title')}</h3>
                <Button
                  id="go-to-buy"
                  onClick={() =>
                    AppActions.navigate(
                      NavUrl.from(PredefinedRoute.products).toString(),
                    )
                  }>
                  {L('shopping')}
                </Button>
              </div>
            ))}

          {cartItems.length > 0 && (
            <CartList
              cartItems={cartItems}
              renderCustomComponent={renderCustomComponent}
              cartItemCustomRenderer={cartItemCustomRenderer}
              cartListCustomRenderer={cartListCustomRenderer}
            />
          )}
        </div>

        <div className="gutter" />

        <div className="side" ref={sideElemRef}>
          <CheckoutSummary
            cart={cart}
            disabled={cartItems.length === 0}
            onClick={() => {
              if (!user?.tmp && !user?.data?.email) {
                modal.warning({
                  title: '尚未驗證信箱',
                  content: (
                    <div>
                      您好，由於您尚未驗證信箱
                      <br />
                      我們需要您的信箱以方便後續服務。
                      <br />
                      點擊按鈕我們將導覽您到信箱驗證頁面
                    </div>
                  ),
                  okText: '點我前往',
                  onOk: () => {
                    AppActions.navigate(new NavUrl('/profile').toString());
                  },
                });
                return;
              }

              tracker.beginCheckout({cart});
              AppActions.navigate(
                NavUrl.from(PredefinedRoute.checkoutInfo).toString(),
              );
            }}
            prevButtonLabel={L('back_products')}
            onPrevClick={() => {
              AppActions.navigate(
                NavUrl.from(PredefinedRoute.products).toString(),
              );
            }}
            {...checkoutSummaryProps}
          />
        </div>
      </div>

      {contextHolder}
    </Wrapper>
  );
}

const Wrapper = styled(CheckoutPageWrapper)``;

function Cart(props) {
  return <CartPage {...props} {...getExtraCartPageProps()} />;
}

export default withPageEntry(Cart);
